export default "__VITE_ASSET__Bj_yBfpo__"